<template>
  <fragment>
    <c-roadmap top-divider />
    <c-generic-section top-divider>
      <div class="container-xs">
        <c-section-header :data="{title: 'Frequently Asked Questions'}" class="center-content" />
        <c-faq-how-it-works :startOpen="true"></c-faq-how-it-works>
        <div class="center-content">
          <c-button color="secondary" tag="router-link" to="/faq">Other Frequently Asked Questions</c-button>
        </div>
      </div>
    </c-generic-section>

    <c-cta split />
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutAlternative.vue";
// import section header
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
// import sections
import CGenericSection from "@/components/sections/GenericSection.vue";
import CRoadmap from "@/components/sections/Roadmap.vue";
import CCta from "@/components/sections/Cta.vue";
import CButton from "@/components/elements/Button.vue";
// import some required elements
import CFaqHowItWorks from "@/components/elements/FaqHowItWorks.vue";

export default {
  name: "Secondary",
  components: {
    CSectionHeader,
    CGenericSection,
    CRoadmap,
    CCta,
    CButton,
    CFaqHowItWorks
  },
  data() {
    return {
      demoModalActive: false
    };
  },
  created() {
    this.$emit("update:layout", CLayout);
  }
};
</script>
